import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useStream(data = {}) {
  const { enabled = false, streamID } = data;
  const { privateFetch } = useContext(FetchContext);

  async function getStreamDetails() {
    return privateFetch.get(`/v1/admin/streams/${streamID}`).then((res) => res.data);
  }

  return useQuery(['stream-details', streamID], getStreamDetails, { enabled });
}

export default useStream;
